import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getStudentClassDashboardDataService } from "@/service/dashboard.service";
import { StudentClassDashboardData } from "@/types/student-class-dashboard.model";
import { RootState } from "../index";

interface StudentClassDashboardState {
  data: StudentClassDashboardData | null;
  loading: boolean;
  error: string | null;
}

const initialState: StudentClassDashboardState = {
  data: null,
  loading: false,
  error: null,
};

export const fetchStudentClassDashboardData = createAsyncThunk(
  "studentClassDashboard/fetchData",
  async () => {
    const response = await getStudentClassDashboardDataService();
    return response.data.data;
  }
);

const studentClassDashboardSlice = createSlice({
  name: "studentClassDashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStudentClassDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudentClassDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchStudentClassDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch student class dashboard data";
      });
  },
});

export const selectStudentClassDashboardData = (state: RootState) =>
  state.studentClassDashboard.data;
export const selectStudentClassDashboardLoading = (state: RootState) =>
  state.studentClassDashboard.loading;
export const selectStudentClassDashboardError = (state: RootState) =>
  state.studentClassDashboard.error;

export default studentClassDashboardSlice.reducer;
